import { UserWithSubscriptions } from '@api/apiCompat';
import { useUser } from '@hooks/api/useUser';

export const useHeight = () => {
  const { data: userData } = useUser();

  // Cast to extended type with subscriptions
  const user = userData as UserWithSubscriptions | undefined;
  const headerAppHeight = user?.subscriptions?.[0]?.stripe_customer_id ? 80 : 130;

  return { headerAppHeight };
};
